import { parseCalendarDate } from '../../dates/index.js';
const blankToNull = (value) => (value.trim() === '' ? null : value.trim());
// The form schema has already checked the day, so parsing here cannot throw on a submitted form.
const blankToCalendarDate = (value) => value.trim() === '' ? null : parseCalendarDate(value.trim());
export function toCustomerLicenseInput(values) {
    return {
        licenseNumber: values.licenseNumber.trim(),
        licenseType: blankToNull(values.licenseType),
        stateId: values.stateId,
        issuedAt: blankToCalendarDate(values.issuedAt),
        expiresAt: blankToCalendarDate(values.expiresAt),
    };
}
//# sourceMappingURL=to-customer-license-input.js.map